import { useCallback, useMemo } from "react";
import Skeleton from "react-loading-skeleton";

import MetricCard from "components/MetricCard";
import Box from "ds/components/Box";

import { OpenTofuMigrationTile } from "../types";

const TILE_TITLES: Record<OpenTofuMigrationTile, string> = {
  [OpenTofuMigrationTile.ReadyToMigrate]: "Ready to migrate",
  [OpenTofuMigrationTile.Queue]: "Queued",
};

type DashboardWidgetsOpenTofuMigrationTilesProps = {
  eligibleToMigrate: number;
  queuedToMigrate: number;
  isLoading: boolean;
  selectedTile: OpenTofuMigrationTile;
  onSelect: (tile: OpenTofuMigrationTile) => void;
};

const DashboardWidgetsOpenTofuMigrationTiles = ({
  eligibleToMigrate,
  queuedToMigrate,
  isLoading,
  selectedTile,
  onSelect,
}: DashboardWidgetsOpenTofuMigrationTilesProps) => {
  const tileValues = useMemo<Record<OpenTofuMigrationTile, number>>(
    () => ({
      [OpenTofuMigrationTile.ReadyToMigrate]: eligibleToMigrate,
      [OpenTofuMigrationTile.Queue]: queuedToMigrate,
    }),
    [eligibleToMigrate, queuedToMigrate]
  );

  const handleSelect = useCallback(
    (tile: OpenTofuMigrationTile) => () => onSelect(tile),
    [onSelect]
  );

  return (
    <Box gap="large" grid gridTemplate="1fr 1fr" fullWidth>
      {Object.values(OpenTofuMigrationTile).map((tile) => (
        <MetricCard
          key={tile}
          selected={selectedTile === tile}
          onClick={handleSelect(tile)}
          titleColor="primary"
          title={TILE_TITLES[tile]}
          value={isLoading ? <Skeleton width={40} height={32} /> : tileValues[tile]}
        />
      ))}
    </Box>
  );
};

export default DashboardWidgetsOpenTofuMigrationTiles;
